<template>
  <box>
    
    <div class="desktop column w700 left" style="margin-bottom: 20vh; margin-top: 15vh">
      <p class="mini">{{ root ? `New ${root.title}` : 'New asset' }}</p>

      <h1 class="mb8"> New asset</h1>

      <!-- type -->
      <!-- <Block hr big title="Category" :error="errors.type" :done="asset.type" must desc="Select an asset category">        
        <div class="row wrap">
          <Tag v-model="asset.type" @click="resetAsset(); root = item" :id="item.id" v-for="(item, index) in dict.roots" :key="index">{{ item.title }}</Tag>                      
        </div>
      </Block> -->
      
      <div >

      <!-- images -->
      <Title><template #desc></template></Title>              
        <div class="row wrap">
          <div class="column" v-for="(item, index) in images" :key="index">
          <Image close @close="tools.delete(images, item)" :src="item.body" />   
          <p v-if="index != 0" class="tag" @click="images.splice(index, 1); images.unshift(item)" >Set main</p>       
          <p v-if="index == 0" class="good">Cover image</p>       
        </div>
        </div>
        <Tag :class="{mt4: images.length}" v-upload.images="loadImages">Upload image</Tag>
        
      </div>

      

      <div v-if="root && images.length">

      <!-- <Title must hr>General<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>         -->

      <!-- category -->      
      <Block v-for="(field, index) in attrFields.filter(p => p.type == 'cat')"  :key="index">
          
        <Block big :error="errors[`${field.name}`]" v-if="dict.list(asset.type, field.name).length" :done="field.done" :must="field.req" :title="field.title" :desc="field.line">
          <div class="row wrap">
              <Tag :special="i.gpt" v-model="asset.attr[`${field.name}`]" @update="asset.attr[`${field.name}/name`] = i.title" :id="i.id" v-for="(i, ii) in dict.list(asset.type, field.name)" :key="ii">{{ i.title }}</Tag>
          </div>
        </Block>
          <!-- subcategory -->
          <!-- {{ field }} -->
          <Block :error="errors[`${field.name}/sub`]" big style="margin-top: 40px;" v-if="asset.attr[`${field.name}`] && dict.list(asset.attr[`${field.name}`], 'models').length" :done="asset.attr[`${field.name}/sub`] || asset.attr[`${field.name}/subname`]"  title="Subcategory">
              <div class="row wrap">
                  <Tag :special="i.gpt" v-model="asset.attr[`${field.name}/sub`]" @update="asset.attr[`${field.name}/subname`] = i.title" :id="i.id" v-for="(i, ii) in dict.list(asset.attr[`${field.name}`], 'models')" :key="ii">{{ i.title }}</Tag>
              </div>
          </Block>
      </Block>

      <!-- brands -->
      <Block v-if="meta.brand.active" :error="errors.brand"  big :title="meta.brand.title || 'Brand'" :done="asset.brand.id || asset.brand.name" :must="meta.brand.must" :desc="meta.brand.desc || 'Select brand'">
        <div class="row wrap mb2">
          <Tag  v-model="asset.brand.id" :id="i.id" @update="asset.brand.name = i.title; asset.brand.submodel = undefined;asset.brand.submodelname = undefined;asset.brand.model = undefined;asset.brand.modelname = undefined " v-for="(i, ii) in brands" :key="ii">{{ i.title }}</Tag>
        </div>
        <Brand v-if="meta.brand.user" :asset="root.id" v-model="asset.brand.name" :placeholder="meta.brand.placeholder || 'Brand...'" @id="asset.brand.id = Number($event)" class="w300 mb4" height="300px"/>
        <!-- @name="asset.brand.name = $event" -->
        <!-- <input v-if="meta[`brand/user`]" class="w300 mb4" type="text" @input="asset.brand.id = undefined" v-model="asset.brand.name" :placeholder="meta[`brand/placeholder`] || 'Brand...'"> -->
      </Block>
        
        <!-- models -->
        <Block :must="meta.model.must" :error="errors.model" style="margin-top: 40px;" v-if="meta.model.active && (asset.brand.id || asset.brand.name)" :done="asset.brand.model || (asset.brand.modelname && asset.brand.modelname != '')"  big :title="meta.model.title || 'Model'">
          <div class="row wrap">                  
            <Tag @click="asset.brand.submodel = undefined; asset.brand.submodelname = undefined" v-model="asset.brand.model" :id="model.id" @update="asset.brand.modelname = model.title" v-for="(model, modelIndex) in models" :key="modelIndex">{{ model.title }}</Tag>
          </div>
          <input v-if="meta.model.user" class="w300 mb4" type="text" @input="asset.brand.model = undefined" v-model="asset.brand.modelname" :placeholder="meta.model.placeholder || 'Model...'">
          <p v-if="dev">{{ asset.brand }}</p>
          <p v-if="dev">{{ asset.brand.model || (asset.brand.modelname && asset.brand.modelname != '') }}</p>
        </Block>

        <!-- submodels -->
        <Block v-if="meta.submodel.active && asset.brand.model && dict.list(asset.brand.model, 'submodels').length" :must="meta.submodel.must" :error="errors.submodel" style="margin-top: 40px;" :done="asset.brand.submodel || asset.brand.submodelname" hr big :title="meta.submodel.title || 'Submodel'">
          <div class="row wrap">                  
            <Tag  v-model="asset.brand.submodel" :id="model.id" @update="asset.brand.submodelname = model.title" v-for="(model, modelIndex) in dict.list(asset.brand.model, 'submodels')" :key="modelIndex">{{ model.title }}</Tag>
          </div>
          <input v-if="meta.submodel.user" class="w300" type="text" @input="asset.brand.submodel = undefined" v-model="asset.brand.submodelname" :placeholder="meta.submodel.placeholder || 'Submodel...'">
        </Block>


         <!-- title -->          
        <Block big v-if="meta.title.active" :error="errors.title" :done="asset.title != ''" :must="meta.title.must" title="Title" desc="What price you purchased an asset">
            <input class="w400" type="text" :placeholder="generatedTitle || 'Title...'" v-model="asset.title">
            <p v-if="generatedTitle" class="tag mt2" @click="asset.title = generatedTitle"> {{ generatedTitle }}</p>          
        </Block>

          <!-- about -->
          <Block big v-if="meta.about.active" :error="errors.about" :must="meta.about.must" title="About" desc="What price you purchased an asset">
            <textarea class="w400" placeholder="Tell us about your asset..."  v-model="asset.about" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
          </Block>

          <!-- location -->
          <Block big v-if="meta.location.active" :error="errors.location" :must="meta.location.must" title="Location" desc="Where is the asset">
            <Geo v-model="asset.location.id" @country="asset.location.country = $event" @city="asset.location.city = $event" @state="asset.location.state = $event"  placeholder="Enter city..." class="w400 nomargin" height="300px"/>        
          </Block>

          <!-- <Title must hr style="margin-top: 100px;">Attributes<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>         -->

        <!-- attr -->      
        <Block hr big :error="errors[`attr/${field.name}`]" v-for="(field, index) in attrFields.filter(p => p.type != 'cat')" :done="field.done" :key="index" :desc="field.line" :must="field.must" :title="`${field.title} ${isMetricField(field.type) ? '/ '+field.type : ''}`">          
            
          <div v-if="field.type == 'switch'">
            <Switch v-model="asset.attr[field.name]"/>            
          </div>

          <!-- <div v-if="['num','mm','cm','m','l','inch'].indexOf(field.type) > -1"> -->
          <div v-if="field.type == 'num'">
            <input class="w200" type="number" v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">
          </div>

          <div v-if="field.type == 'text'">          
             <input class="w300" type="text"  v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">             
          </div>

          <div v-if="field.type == 'md'"> 
            <textarea class="w500" rows="4" v-model="asset.attr[field.name]" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
          </div>

          <div v-if="field.type == 'price'">
            <Price class="w300" :currency="asset.attr[field.name+'/curr']" @currency="asset.attr[field.name+'/curr'] = $event" v-model.number="asset.attr[field.name]"></Price>                      
          </div>

          <div class="w300" v-if="field.type == 'country'">
            <select class="formselect" style="width: 100%;" v-model="asset.attr[field.name]">
              <optgroup label="Top"><option v-for="(country, countryIndex) in dict.countries.filter(c => c.top)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>
              <optgroup label="Favorites"><option v-for="(country, countryIndex) in dict.countries.filter(c => c.eu)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>
              <optgroup label="Other"><option v-for="(country, countryIndex) in dict.countries.filter(c => !c.eu && !c.top)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>              
            </select>    
          </div>

          <div v-if="field.type == 'city'">
            <Geo v-model="asset.attr[field.name]" @country="asset.attr[`${field.name}/country`] = $event" @city="asset.attr[`${field.name}/city`] = $event" @state="asset.attr[`${field.name}/state`] = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>                    
          </div>

          <div v-if="field.type == 'address'">
            <p class="desc mb1" :class="{must: field.req}">City</p>            
            <Geo v-model="asset.attr[field.name]" @country="asset.attr[`${field.name}/country`] = $event" @city="asset.attr[`${field.name}/city`] = $event" @state="asset.attr[`${field.name}/state`] = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
            <p class="desc mt4" :class="{must: field.req}">Address</p>
            <input class="w300" type="text" v-model="asset.attr[`${field.name}/address`]" :placeholder="field.placeholder || 'Address'">
          </div>

          <div v-if="field.type == 'image'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload image...</p>              
          </div>
          
          <div v-if="field.type == 'file'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload file...</p>              
          </div>

          <div v-if="field.type == 'doc'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload document...</p>              
          </div>

          <div v-if="field.type == 'url'">
            <input class="w300 mb4" type="text" v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">
          </div>      

          <div v-if="isMetricField(field.type)">  
              <Number class="w100" min="150px" v-model.number="asset.attr[field.name]">{{field.type}}</Number>                            
          </div>

          <div v-if="field.type == 'year'">
            <Year class="w100" v-model.number="asset.attr[field.name]"></Year>            
          </div>      

          <div v-if="field.type == 'date'">
            <!-- 2024-03-14 -->
            <input class="w300" type="date" @input="asset.attr[field.name] = stringToDate($event)" :placeholder="field.placeholder || field.title">
           </div>

          <div v-if="field.type == 'list'">
              <div v-if="field.multi" class="row wrap mt4">
                  <p class="tag" :class="{active: tools.has(asset.attr[field.name], listItem.id)}" v-for="(listItem, listIndex) in dict.list(asset.type, field.name)" @click="tools.push(asset.attr[field.name], listItem.id)" :key="listIndex">{{ listItem.title }}</p>                                                
              </div>
              <div v-else>
                <div class="row wrap">
                    <Tag v-model.number="asset.attr[field.name]" :id="item.id" v-for="(item, metricIndex) in dict.list(asset.type, field.name)" @update="asset.attr[`${field.name}/user`] = undefined" :key="metricIndex">{{ item.title }}</Tag>                                                
                </div>
                <input v-if="field.custom" @input="asset.attr[field.name] = undefined" class="w300 mt4" type="text" v-model="asset.attr[`${field.name}/user`]" :placeholder="field.placeholder || field.title">
              </div>              
           </div>


        </Block>


        <!-- purchase -->
        <Block style="margin-top: 50px;">
          <Title hr must>Purchase<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>        
          <Block :must="meta.purchase.price.must" v-if="meta.purchase.price.active" title="Price" desc="What price you purchased an asset">
            <Price class="w300" :currency="asset.purchase.curr" @currency="asset.purchase.curr = $event" v-model.number="asset.purchase.price"></Price>          
          </Block>
          <Block :must="meta.purchase.location.must" v-if="meta.purchase.location.active && !meta.purchase.address.active" title="Location" desc="Where you purchased an asset">
            <Geo v-model="asset.purchase.geoid" @country="asset.purchase.country = $event" @city="asset.purchase.city = $event" @state="asset.purchase.state = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
          </Block>
          <Block :must="meta.purchase.address.must" v-if="meta.purchase.address.active" title="Address" desc="Have an ogirinal asset box">
            <!-- <p class="desc mb1">City</p> -->
            <Geo v-model="asset.purchase.geoid" @country="asset.purchase.country = $event" @city="asset.purchase.city = $event" @state="asset.purchase.state = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
            <!-- <p class="desc mt4">Address</p> -->
            <input class="w300" type="text" v-model="asset.purchase.address" :placeholder="'Address'">
          </Block>
          <Block :must="meta.purchase.year.must" v-if="meta.purchase.year.active" title="Year" desc="When you purchased an asset">
            <Year class="w100" v-model.number="asset.purchase.year"></Year>          
          </Block>
          <Block :must="meta.purchase.reciept.must" :done="waitfiles.reciept" v-if="meta.purchase.reciept.active" title="Reciept" desc="When you purchased an asset">
            
            <File v-if="waitfiles.reciept" v-upload="uploadReciept" close @close="waitfiles.reciept = undefined" :file="waitfiles.reciept"/>          
            <p v-if="!waitfiles.reciept" class="tag" v-upload="uploadReciept">Upload file...</p>
          </Block>
          <Block  v-if="meta.purchase.auction.active" title="Auction Sales" desc="Do you bougth asset on auction?">
            <Switch v-model="asset.purchase.auction"></Switch>
          </Block>
          <Block  v-if="meta.purchase.box.active" title="Original Package" desc="Have an ogirinal asset box">
            <Switch v-model="asset.purchase.box"></Switch>
          </Block>
         

        </Block>
        
      
      

      <!-- docs -->
     <!--  <Block style="margin-top: 50px;">
        <Title must hr>Docs<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>        
        <div class="row wrap">
          <File close @close="tools.delete(docs, item)" :file="item" v-for="(item, index) in docs" :key="index"/>          
        </div>
        <Tag :class="{mt4: images.length}" v-upload.docs="uploadDocs">Upload documents...</Tag>
      </Block> -->


      <!-- publish -->
      <Block :error="errors.has" style="margin-top: 50px;">
        <!-- <Title hr>Publish<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title> -->

        <!-- <h2 class="must">Publish</h2>        
        <p class="desc">Tell us where, when and for how much you acquired this asset.</p>                
        <hr> -->

            
            <!-- status -->
          <!-- <Block big title="Status" desc="You could set asset status but its optional">
            <div class="row wrap">
              <p class="tag" :title="item.desc" :class="{active: asset.status == item.id}" @click="asset.status = item.id" v-for="(item, index) in dict.realStatus" :key="index">{{ item.title }}</p>      
            </div>            
          </Block> -->

          <div v-if="Object.keys(errors).length" class="column mb4" style="color: #C92D40; font-size: 14px ;font-weight: 400;">
            <p>There is some mistakes in:</p> 
            <li v-for="(item, index) in errors" :key="index">{{ tools.title( index )}}</li>
          </div>

          <!-- <p class="mini mb2">Send to valid asset</p> -->
          <div class="row"><p class="button big fill" style="margin: 0;" @click="create()">{{Object.keys(errors).length > 0 ? 'Try again': 'Send'}}</p></div>      
          

      </Block>


   
    <Block v-if="dev" big title="Tech" desc="Dev proposition" style="margin-top: 150px;">
      <code>
        <table>
          <tr class="hover" v-for="(item, index) in asset" :key="index">          
            <td class="w150" v-if="index != 'attr'">{{ index }}</td>
            <td v-if="index != 'attr'">{{ item }}</td>
          </tr>
          <tr>
            <td colspan="2" class="bold">Attr</td>            
          </tr>
          <tr class="hover" v-for="(item, index) in asset.attr" :key="index">          
            <td class="w150">{{ index }}</td>
            <td >{{ item }}</td>
          </tr>
        </table>      
        
        <br>
        <br>
        
          {{ JSON.stringify(asset, null, 3) }}
          <br>
          {{ JSON.stringify(meta, null, 3) }}
        
        
        
      </code>
    </Block>

  </div>
    
  </div>
    
  
  <div class="mobile column left" style="width: 100vw; overflow-x: hidden; padding: 5vh 10vw 20vh;">
      <p class="mini">{{ root ? `New ${root.title}` : 'New asset' }}</p>

      <h1 class="mb8">New asset</h1>

      <!-- type -->
      <Block hr big title="Category" :error="errors.type" :done="asset.type" must desc="Select an asset category">        
            <div class="row wrap">
              <Tag v-model="asset.type" @click="resetAsset(); root = item" :id="item.id" v-for="(item, index) in dict.roots" :key="index">{{ item.title }}</Tag>                      
            </div>
          </Block>

      <!-- images -->
      <Title must hr>Images<template #desc>{{ minimumImages ? `Minimum — ${minimumImages} images.`:``  }} Tell us where, when and for how much you acquired this asset.</template></Title>              
        <div class="row wrap">
          <div class="column" v-for="(item, index) in images" :key="index">
          <Image close @close="tools.delete(images, item)" :src="item.body" />   
          <p v-if="index != 0" class="tag" @click="images.splice(index, 1); images.unshift(item)" >Set main</p>       
          <p v-if="index == 0" class="good">Cover image</p>       
        </div>
        </div>
        <Tag :class="{mt4: images.length}" v-upload.images="loadImages">Add images...</Tag>
        
        
          <br>          
          
        

      

      <div v-if="root">

      <!-- <Title must hr>General<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>         -->

      <!-- category -->      
      <Block v-for="(field, index) in attrFields.filter(p => p.type == 'cat')"  :key="index">
          
        <Block big :error="errors[`${field.name}`]" v-if="dict.list(asset.type, field.name).length" :done="field.done" :must="field.req" :title="field.title" :desc="field.line">
          <div class="row wrap">
              <Tag :special="i.gpt" v-model="asset.attr[`${field.name}`]" @update="asset.attr[`${field.name}/name`] = i.title" :id="i.id" v-for="(i, ii) in dict.list(asset.type, field.name)" :key="ii">{{ i.title }}</Tag>
          </div>
        </Block>
          <!-- subcategory -->
          <!-- {{ field }} -->
          <Block :error="errors[`${field.name}/sub`]" big style="margin-top: 40px;" v-if="asset.attr[`${field.name}`] && dict.list(asset.attr[`${field.name}`], 'models').length" :done="asset.attr[`${field.name}/sub`] || asset.attr[`${field.name}/subname`]"  title="Subcategory">
              <div class="row wrap">
                  <Tag :special="i.gpt" v-model="asset.attr[`${field.name}/sub`]" @update="asset.attr[`${field.name}/subname`] = i.title" :id="i.id" v-for="(i, ii) in dict.list(asset.attr[`${field.name}`], 'models')" :key="ii">{{ i.title }}</Tag>
              </div>
          </Block>
      </Block>

      <!-- brands -->
      <Block v-if="meta.brand.active" :error="errors.brand"  big :title="meta.brand.title || 'Brand'" :done="asset.brand.id || asset.brand.name" :must="meta.brand.must" :desc="meta.brand.desc || 'Select brand'">
        <div class="row wrap mb2">
          <Tag  v-model="asset.brand.id" :id="i.id" @update="asset.brand.name = i.title; asset.brand.submodel = undefined;asset.brand.submodelname = undefined;asset.brand.model = undefined;asset.brand.modelname = undefined " v-for="(i, ii) in brands" :key="ii">{{ i.title }}</Tag>
        </div>
        <Brand v-if="meta.brand.user" :asset="root.id" v-model="asset.brand.name" :placeholder="meta.brand.placeholder || 'Brand...'" @id="asset.brand.id = Number($event)" class="w300 mb4" height="300px"/>
        <!-- @name="asset.brand.name = $event" -->
        <!-- <input v-if="meta[`brand/user`]" class="w300 mb4" type="text" @input="asset.brand.id = undefined" v-model="asset.brand.name" :placeholder="meta[`brand/placeholder`] || 'Brand...'"> -->
      </Block>
        
        <!-- models -->
        <Block :must="meta.model.must" :error="errors.model" style="margin-top: 40px;" v-if="meta.model.active && (asset.brand.id || asset.brand.name)" :done="asset.brand.model || (asset.brand.modelname && asset.brand.modelname != '')"  big :title="meta.model.title || 'Model'">
          <div class="row wrap">                  
            <Tag @click="asset.brand.submodel = undefined; asset.brand.submodelname = undefined" v-model="asset.brand.model" :id="model.id" @update="asset.brand.modelname = model.title" v-for="(model, modelIndex) in models" :key="modelIndex">{{ model.title }}</Tag>
          </div>
          <input v-if="meta.model.user" class="w300 mb4" type="text" @input="asset.brand.model = undefined" v-model="asset.brand.modelname" :placeholder="meta.model.placeholder || 'Model...'">
          <p v-if="dev">{{ asset.brand }}</p>
          <p v-if="dev">{{ asset.brand.model || (asset.brand.modelname && asset.brand.modelname != '') }}</p>
        </Block>

        <!-- submodels -->
        <Block v-if="meta.submodel.active && asset.brand.model && dict.list(asset.brand.model, 'submodels').length" :must="meta.submodel.must" :error="errors.submodel" style="margin-top: 40px;" :done="asset.brand.submodel || asset.brand.submodelname" hr big :title="meta.submodel.title || 'Submodel'">
          <div class="row wrap">                  
            <Tag  v-model="asset.brand.submodel" :id="model.id" @update="asset.brand.submodelname = model.title" v-for="(model, modelIndex) in dict.list(asset.brand.model, 'submodels')" :key="modelIndex">{{ model.title }}</Tag>
          </div>
          <input v-if="meta.submodel.user" class="w300" type="text" @input="asset.brand.submodel = undefined" v-model="asset.brand.submodelname" :placeholder="meta.submodel.placeholder || 'Submodel...'">
        </Block>


         <!-- title -->          
        <Block big v-if="meta.title.active" :error="errors.title" :done="asset.title != ''" :must="meta.title.must" title="Title" desc="What price you purchased an asset">
            <input class="w400" type="text" :placeholder="generatedTitle || 'Title...'" v-model="asset.title">
            <p v-if="generatedTitle" class="tag mt2" @click="asset.title = generatedTitle"> {{ generatedTitle }}</p>          
        </Block>

          <!-- about -->
          <Block big v-if="meta.about.active" :error="errors.about" :must="meta.about.must" title="About" desc="What price you purchased an asset">
            <textarea class="w400" placeholder="Tell us about your asset..."  v-model="asset.about" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
          </Block>

          <!-- location -->
          <Block big v-if="meta.location.active" :error="errors.location" :must="meta.location.must" title="Location" desc="Where is the asset">
            <Geo v-model="asset.location.id" @country="asset.location.country = $event" @city="asset.location.city = $event" @state="asset.location.state = $event"  placeholder="Enter city..." class="w400 nomargin" height="300px"/>        
          </Block>

          <!-- <Title must hr style="margin-top: 100px;">Attributes<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>         -->

        <!-- attr -->      
        <Block hr big :error="errors[`attr/${field.name}`]" v-for="(field, index) in attrFields.filter(p => p.type != 'cat')" :done="field.done" :key="index" :desc="field.line" :must="field.must" :title="`${field.title} ${isMetricField(field.type) ? '/ '+field.type : ''}`">          
            
          <div v-if="field.type == 'switch'">
            <Switch v-model="asset.attr[field.name]"/>            
          </div>

          <!-- <div v-if="['num','mm','cm','m','l','inch'].indexOf(field.type) > -1"> -->
          <div v-if="field.type == 'num'">
            <input class="w200" type="number" v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">
          </div>

          <div v-if="field.type == 'text'">          
             <input class="w300" type="text"  v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">             
          </div>

          <div v-if="field.type == 'md'"> 
            <textarea class="w500" rows="4" v-model="asset.attr[field.name]" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
          </div>

          <div v-if="field.type == 'price'">
            <Price class="w300" :currency="asset.attr[field.name+'/curr']" @currency="asset.attr[field.name+'/curr'] = $event" v-model.number="asset.attr[field.name]"></Price>                      
          </div>

          <div class="w300" v-if="field.type == 'country'">
            <select class="formselect" style="width: 100%;" v-model="asset.attr[field.name]">
              <optgroup label="Top"><option v-for="(country, countryIndex) in dict.countries.filter(c => c.top)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>
              <optgroup label="Favorites"><option v-for="(country, countryIndex) in dict.countries.filter(c => c.eu)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>
              <optgroup label="Other"><option v-for="(country, countryIndex) in dict.countries.filter(c => !c.eu && !c.top)" :key="countryIndex" :value="country.id">{{ country.flag }} {{ country.title }}</option></optgroup>              
            </select>    
          </div>

          <div v-if="field.type == 'city'">
            <Geo v-model="asset.attr[field.name]" @country="asset.attr[`${field.name}/country`] = $event" @city="asset.attr[`${field.name}/city`] = $event" @state="asset.attr[`${field.name}/state`] = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>                    
          </div>

          <div v-if="field.type == 'address'">
            <p class="desc mb1" :class="{must: field.req}">City</p>            
            <Geo v-model="asset.attr[field.name]" @country="asset.attr[`${field.name}/country`] = $event" @city="asset.attr[`${field.name}/city`] = $event" @state="asset.attr[`${field.name}/state`] = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
            <p class="desc mt4" :class="{must: field.req}">Address</p>
            <input class="w300" type="text" v-model="asset.attr[`${field.name}/address`]" :placeholder="field.placeholder || 'Address'">
          </div>

          <div v-if="field.type == 'image'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload image...</p>              
          </div>
          
          <div v-if="field.type == 'file'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload file...</p>              
          </div>

          <div v-if="field.type == 'doc'">
              <p class="tag" v-upload="uploadOne(field, $event)">Upload document...</p>              
          </div>

          <div v-if="field.type == 'url'">
            <input class="w300 mb4" type="text" v-model="asset.attr[field.name]" :placeholder="field.placeholder || field.title">
          </div>      

          <div v-if="isMetricField(field.type)">  
              <Number class="w100" min="150px" v-model.number="asset.attr[field.name]">{{field.type}}</Number>                            
          </div>

          <div v-if="field.type == 'year'">
            <Year class="w100" v-model.number="asset.attr[field.name]"></Year>            
          </div>      

          <div v-if="field.type == 'date'">
            <!-- 2024-03-14 -->
            <input class="w300" type="date" @input="asset.attr[field.name] = stringToDate($event)" :placeholder="field.placeholder || field.title">
           </div>

          <div v-if="field.type == 'list'">
              <div v-if="field.multi" class="row wrap mt4">
                  <p class="tag" :class="{active: tools.has(asset.attr[field.name], listItem.id)}" v-for="(listItem, listIndex) in dict.list(asset.type, field.name)" @click="tools.push(asset.attr[field.name], listItem.id)" :key="listIndex">{{ listItem.title }}</p>                                                
              </div>
              <div v-else>
                <div class="row wrap">
                    <Tag v-model.number="asset.attr[field.name]" :id="item.id" v-for="(item, metricIndex) in dict.list(asset.type, field.name)" @update="asset.attr[`${field.name}/user`] = undefined" :key="metricIndex">{{ item.title }}</Tag>                                                
                </div>
                <input v-if="field.custom" @input="asset.attr[field.name] = undefined" class="w300 mt4" type="text" v-model="asset.attr[`${field.name}/user`]" :placeholder="field.placeholder || field.title">
              </div>              
           </div>


        </Block>


        <!-- purchase -->
        <Block style="margin-top: 50px;">
          <Title hr must>Purchase<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>        
          <Block :must="meta.purchase.price.must" v-if="meta.purchase.price.active" title="Price" desc="What price you purchased an asset">
            <Price class="w300" :currency="asset.purchase.curr" @currency="asset.purchase.curr = $event" v-model.number="asset.purchase.price"></Price>          
          </Block>
          <Block :must="meta.purchase.location.must" v-if="meta.purchase.location.active && !meta.purchase.address.active" title="Location" desc="Where you purchased an asset">
            <Geo v-model="asset.purchase.geoid" @country="asset.purchase.country = $event" @city="asset.purchase.city = $event" @state="asset.purchase.state = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
          </Block>
          <Block :must="meta.purchase.address.must" v-if="meta.purchase.address.active" title="Address" desc="Have an ogirinal asset box">
            <!-- <p class="desc mb1">City</p> -->
            <Geo v-model="asset.purchase.geoid" @country="asset.purchase.country = $event" @city="asset.purchase.city = $event" @state="asset.purchase.state = $event"  placeholder="Enter city..." class="w300 nomargin" height="300px"/>        
            <!-- <p class="desc mt4">Address</p> -->
            <input class="w300" type="text" v-model="asset.purchase.address" :placeholder="'Address'">
          </Block>
          <Block :must="meta.purchase.year.must" v-if="meta.purchase.year.active" title="Year" desc="When you purchased an asset">
            <Year class="w100" v-model.number="asset.purchase.year"></Year>          
          </Block>
          <Block :must="meta.purchase.reciept.must" :done="waitfiles.reciept" v-if="meta.purchase.reciept.active" title="Reciept" desc="When you purchased an asset">
            
            <File v-if="waitfiles.reciept" v-upload="uploadReciept" close @close="waitfiles.reciept = undefined" :file="waitfiles.reciept"/>          
            <p v-if="!waitfiles.reciept" class="tag" v-upload="uploadReciept">Upload file...</p>
          </Block>
          <Block  v-if="meta.purchase.auction.active" title="Auction Sales" desc="Do you bougth asset on auction?">
            <Switch v-model="asset.purchase.auction"></Switch>
          </Block>
          <Block  v-if="meta.purchase.box.active" title="Original Package" desc="Have an ogirinal asset box">
            <Switch v-model="asset.purchase.box"></Switch>
          </Block>
         

        </Block>
        
      
      

      <!-- docs -->
     <!--  <Block style="margin-top: 50px;">
        <Title must hr>Docs<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title>        
        <div class="row wrap">
          <File close @close="tools.delete(docs, item)" :file="item" v-for="(item, index) in docs" :key="index"/>          
        </div>
        <Tag :class="{mt4: images.length}" v-upload.docs="uploadDocs">Upload documents...</Tag>
      </Block> -->


      <!-- publish -->
      <Block :error="errors.has" style="margin-top: 50px;">
        <!-- <Title hr>Publish<template #desc>Tell us where, when and for how much you acquired this asset.</template></Title> -->

        <!-- <h2 class="must">Publish</h2>        
        <p class="desc">Tell us where, when and for how much you acquired this asset.</p>                
        <hr> -->

            
            <!-- status -->
          <!-- <Block big title="Status" desc="You could set asset status but its optional">
            <div class="row wrap">
              <p class="tag" :title="item.desc" :class="{active: asset.status == item.id}" @click="asset.status = item.id" v-for="(item, index) in dict.realStatus" :key="index">{{ item.title }}</p>      
            </div>            
          </Block> -->

          <div v-if="Object.keys(errors).length" class="column mb4" style="color: #C92D40; font-size: 14px ;font-weight: 400;">
            <p>There is some mistakes in:</p> 
            <li v-for="(item, index) in errors" :key="index">{{ tools.title( index )}}</li>
          </div>

          <!-- <p class="mini mb2">Send to valid asset</p> -->
          <div class="row"><p class="button big fill" style="margin: 0;" @click="create()">{{Object.keys(errors).length > 0 ? 'Try again': 'Send'}}</p></div>      
          

      </Block>


   
    <Block v-if="dev" big title="Tech" desc="Dev proposition" style="margin-top: 150px;">
      <code>
        <table>
          <tr class="hover" v-for="(item, index) in asset" :key="index">          
            <td class="w150" v-if="index != 'attr'">{{ index }}</td>
            <td v-if="index != 'attr'">{{ item }}</td>
          </tr>
          <tr>
            <td colspan="2" class="bold">Attr</td>            
          </tr>
          <tr class="hover" v-for="(item, index) in asset.attr" :key="index">          
            <td class="w150">{{ index }}</td>
            <td >{{ item }}</td>
          </tr>
        </table>      
        
        <br>
        <br>
        
          {{ JSON.stringify(asset, null, 3) }}
          <br>
          {{ JSON.stringify(meta, null, 3) }}
        
        
        
      </code>
    </Block>

  </div>
    
  </div>
</box>
    
    
    <!-- success -->   
    <Popup v-model="progress.status" up="Asset"  :title="`${progress.status}`" >
      <template #icon>
        <br>
        <Loader v-if="progress.status != 'Done'" width="60px" color="#A3568F" borders="4px solid #0000"/>
          <div v-else>
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="#4CAF50"/><path d="M45.1424 16.5714L25.7139 36L17.7139 28L13.7139 32L25.7139 44L49.1424 20.5714L45.1424 16.5714Z" fill="#CCFF90"/></svg>
          </div>
        
      </template>
        
        <div class="column w300 center" style="height: 20vh; margin-bottom: 50px;">
          <table style="width: 90%;" >
            <tr>
              <td class="fit" v-if="progress.valid"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#4CAF50"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="#CCFF90"/></svg></td>
              <td class="fit" v-if="!progress.valid"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" fill-opacity="0.08"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="white" fill-opacity="0.14"/></svg></td>
              <td class="tt">Validation...</td>              
            </tr>
            <tr>
              <td class="fit" v-if="progress.images"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#4CAF50"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="#CCFF90"/></svg></td>
              <td class="fit" v-if="!progress.images"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" fill-opacity="0.08"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="white" fill-opacity="0.14"/></svg></td>
              <td class="tt">Images uploading...</td>              
            </tr>
            <tr>
              <td class="fit" v-if="progress.files"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#4CAF50"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="#CCFF90"/></svg></td>
              <td class="fit" v-if="!progress.files"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" fill-opacity="0.08"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="white" fill-opacity="0.14"/></svg></td>
              <td class="tt">Files uploading...</td>              
            </tr>
            <tr>
              <td class="fit" v-if="progress.done"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#4CAF50"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="#CCFF90"/></svg></td>
              <td class="fit" v-if="!progress.done"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" fill-opacity="0.08"/><path d="M15.0475 5.5238L8.57129 12L5.90462 9.33333L4.57129 10.6667L8.57129 14.6667L16.3808 6.85714L15.0475 5.5238Z" fill="white" fill-opacity="0.14"/></svg></td>
              <td class="tt">Publishing...</td>              
            </tr>
          </table>          
        </div>
        
        <div class="row center padding">
          <p v-if="progress.status == 'Done'" @click="resetProgress()" class="button margin">OK</p>
          <p v-else class="button margin" @click="progress.cancel = true; resetProgress()">Cancel</p>
        </div>
          
        
        
    </Popup>

    <!-- success -->   
    <Popup v-model="success" done style="z-index: 2000;">
        <!-- <template #icon><svg width="40" height="38" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.7732 35.6878C36.8472 30.6903 32.3381 27.1069 27.0759 25.4081C29.6788 23.8773 31.7011 21.5447 32.8323 18.7685C33.9634 15.9923 34.1408 12.9261 33.3372 10.0406C32.5337 7.15518 30.7936 4.6101 28.3842 2.79624C25.9748 0.982365 23.0293 0 20 0C16.9707 0 14.0252 0.982365 11.6158 2.79624C9.20642 4.6101 7.46632 7.15518 6.66276 10.0406C5.8592 12.9261 6.03661 15.9923 7.16774 18.7685C8.29888 21.5447 10.3212 23.8773 12.9241 25.4081C7.66191 27.105 3.1528 30.6884 0.226774 35.6878C0.119472 35.8606 0.0482988 36.0529 0.0174547 36.2534C-0.0133895 36.4539 -0.00328005 36.6584 0.0471865 36.8549C0.097653 37.0515 0.187455 37.2361 0.311292 37.3977C0.43513 37.5594 0.590496 37.695 0.768223 37.7964C0.945949 37.8978 1.14244 37.9631 1.34609 37.9882C1.54975 38.0134 1.75645 37.9981 1.95399 37.943C2.15154 37.888 2.33593 37.7945 2.49629 37.6679C2.65665 37.5414 2.78973 37.3844 2.88767 37.2062C6.50725 31.0263 12.9049 27.3365 20 27.3365C27.0951 27.3365 33.4927 31.0263 37.1123 37.2062C37.2103 37.3844 37.3433 37.5414 37.5037 37.6679C37.6641 37.7945 37.8485 37.888 38.046 37.943C38.2435 37.9981 38.4502 38.0134 38.6539 37.9882C38.8576 37.9631 39.054 37.8978 39.2318 37.7964C39.4095 37.695 39.5649 37.5594 39.6887 37.3977C39.8125 37.2361 39.9023 37.0515 39.9528 36.8549C40.0033 36.6584 40.0134 36.4539 39.9825 36.2534C39.9517 36.0529 39.8805 35.8606 39.7732 35.6878ZM9.24115 13.6708C9.24115 11.5687 9.87215 9.51367 11.0543 7.76576C12.2365 6.01786 13.9168 4.65553 15.8828 3.85105C17.8487 3.04658 20.0119 2.83609 22.0989 3.24621C24.186 3.65633 26.103 4.66863 27.6077 6.1551C29.1123 7.64157 30.137 9.53546 30.5521 11.5973C30.9673 13.6591 30.7542 15.7962 29.9399 17.7383C29.1256 19.6805 27.7466 21.3405 25.9773 22.5084C24.208 23.6763 22.1279 24.2997 20 24.2997C17.1475 24.2967 14.4127 23.1759 12.3957 21.1833C10.3787 19.1906 9.2442 16.4889 9.24115 13.6708Z" fill="var(--special)"/></svg></template> -->
        <template #title>Success!</template>
        <template #line>You has been create an asset</template>        
        <div class="row" style="padding: 0 20px;">
          <p class="button">Done</p>
          <p class="button">Go to asset page</p>
        </div>
    </Popup>

    
</template>
<script>
/* eslint-disable */ 
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {          
    this.dict.refresh()
    this.asset.type = this.type
    this.resetAsset()
    this.getBrands()
  },
  
  data() {
    return {  
      type: undefined,
      root: undefined,
      showAccountSearch: false,
      showAccountCreate: false,
      success : false,

      user: {},
      id: undefined, 
      error: undefined, 

      errors:{},
      
      images:[],      
      docs:[],

      branditems:[],
      modelitems:[],

      waitfiles:{},
      progress:{
        status: undefined, //now
        valid: false,                
        images: false,
        files: false,
        done: false,
        cancel: false,
        error: undefined,                
      },
      
    asset: {              
      // id: 0, //int sql{inc} #readonly
      // uid: 0, //int sql{index} go{must name="User"} user id #readonly
      // sid: undefined, //string #readonly
      // created: 0, //int64 sql{unix} #readonly
      // updated: 0, //int64 sql{unix} #readonly
      // up: 0, //int64 #readonly
      // status: 0, //int sql{index defaults} #readonly #field
      type: 0, //int go{must} sql{idx="cat" defaults} title{Type} art, cars, books, estate, nft, furniture #must
      title: undefined, //string CLS-500, Submariner, Woman in Red #field
      about: undefined, //string md #field
      image: undefined, //string full image
      search: undefined, //string sql{search="tsv"} swift{skip}
      attr: {}, //map[string]any attributes sql{index} go{name="Attr"}
      price: {}, //map[string]any 
      purchase: {}, //map[string]any 
      location: {}, //map[string]any sql{index}
      brand: {}, //map[string]any sql{index}
      images: {}, //map[string]any hash = []file
      meta: {}, //map[string]any 
      },  
                
    }
  },
  watch: {
      user(val){ this.asset.uid = val.id},
      assetType(v){ this.getBrands()},
      assetBrand(v){ this.getModels()},
    },
  computed: {

      assetType(){return this.asset.type},
      assetBrand(){return this.asset.brand.id},
      minimumImages(){return this.meta.images.min || 1},
      
      
        
      
      attrFields(){
        let list = this.dict.attr.list(this.asset.type).filter(item => item.active)
        list.sort((a,b) => {
          if (a.type == 'brands') return false
          if (a.type == 'category') return false
          return a.id - b.id
        });
        
        let asset = this.asset
        list.forEach(item => {          
          let type = item.type
          let name = item.name
          let multi = item.multi
            // custom, req, dict, multi
          let typeItem = this.dict.getType(type)
          
          if (typeItem.metric) {item.metric = true, item.done = asset.attr[name]}
          if (typeItem.files) item.done = asset.attr[name]
          
          switch (type) {
            case 'switch':    {item.done = multi ? asset.attr[name].length : true; break}
            case 'num':       {item.done = multi ? asset.attr[name].length : asset.attr[name] > 0; break}
            case 'text':      {item.done = multi ? asset.attr[name].length : asset.attr[name]; break}
            case 'md':        {item.done = asset.attr[name]; break}
            case 'price':     {item.done = asset.attr[name] && asset.attr[name+'/curr']; break}
            case 'country':   {item.done = asset.attr[name]; break}
            case 'city':      {item.done = asset.attr[name]; break}
            case 'address':   {item.done = asset.attr[name] && asset.attr[name+'/address']; break}            
            case 'url':       {item.done = asset.attr[name]; break}
            case 'brands':    {item.done = asset.brand.id || asset.brand.name; break}
            case 'cat':       {item.done = asset.attr[name]; break}
            case 'list':      {item.done = asset.attr[name]; break}
            case 'year':      {item.done = asset.attr[name]; break}            
            case 'date':      {item.done = asset.attr[name]; break}        
            default:
              return
          }
        });
        return list
      },


      title(){ 
        let list = []        
        let c = this.asset               
        if (c.brand.name) list.push(c.brand.name)        
        if (c.brand.modelname) list.push(c.brand.modelname)
        return list.join(' ') || 'New asset'
      },

      generatedTitle(){
        let list = []
        let asset = this.asset
        if (asset.brand.name) list.push(asset.brand.name)
        if (asset.brand.modelname) list.push(asset.brand.modelname)        
        if (asset.brand.submodelname) list.push(asset.brand.submodelname)        
        return list.join(' ')
      },

      category(){
        return this.root || {}
        // if (!this.asset.type) return {}        
        // let item = this.dict.get(this.asset.type)
        // console.log("type", item)
        // if (!item) return {}
        // return item || {}
      },
      
      meta(){
        if (!this.root) return {brand:{},model:{},submodel:{},title:{},location:{},about:{},purchase:{}, images:{min:1}}
        return this.root.settings || {brand:{},model:{},submodel:{},title:{},location:{},about:{},purchase:{}, images:{min:1}}
      },
      

      
      brands(){ return this.branditems || []},
      models(){ return this.modelitems || []},

  },
  
  methods: {

    stringToDate(v){    
      // console.log('str2unix',v.target.value)  
      let n = new Date(v.target.value)
      // console.log('str2unix',n)  
      return Math.floor(n.getTime() / 1000)
    },

    isMetricField(type){
      return ['mm','cm','m','l','inch'].indexOf(type) > -1
      // return this.dict.types.find(p => p.id == name && p.metric) || false          
    },

    uploadOne(field, files){
      if (!files) return
      let file = files[0]
      this.waitfiles[field] = file
      // console.log('add file', field, 'files', files)
      return
    },

    uploadReciept(files){
      this.uploadOne('reciept',files)
    },

    uploadMulti(field, files){
      return
    },

    async loadImages(files){
      console.log(files)
      for (let x = 0; x < files.length; x++) {
        const file = files[x];
        let body = await this.tools.readFileAsBase64(file)
        let gptres = await this.api.send('assets/guess', {type: this.asset.type, image: body})
        if (!gptres || !gptres.resp ) {
          console.error('gpt',gptres)
          return
        }
        this.asset = gptres.resp
        this.images.push({file,body})        
      }
    },

    async uploadImage(file){
        let body = await this.tools.readFileAsBytes(file)
        let res = await this.api.upload.image(body)
        console.log(res)
        if (res.error){
          console.error(res.error)
          this.progress.status = 'Error'
          this.progress.error = `Images upload problem: ${res.error}`
          return
        }
        return res.resp.link //link
    },
    
    async uploadDocs(files){
      console.log(files)
      for (let x = 0; x < files.length; x++) {
        const file = files[x];
        this.docs.push(file)    
      }      
      return
    },

    async uploadFile(files){
      console.log(files)
      for (let x = 0; x < files.length; x++) {
        const file = files[x];
        this.docs.push(file)    
      }      
      return
    },    

    setUser(user){
      this.user = user
      this.asset.uid = user.id      
      this.dict.accounts[user.id] = user;
    },

    resetAsset(){
      
      let asset = {        
        // id: 0, //int sql{inc} #readonly
        // uid: 0, //int sql{index} go{must name="User"} user id #readonly
        // sid: "", //string #readonly
        // created: 0, //int64 sql{unix} #readonly
        // updated: 0, //int64 sql{unix} #readonly
        // up: 0, //int64 #readonly
        // status: 0, //int sql{index defaults} #readonly #field
        type: 0, //int go{must} sql{idx="cat" defaults} title{Type} art, cars, books, estate, nft, furniture #must
        title: "", //string CLS-500, Submariner, Woman in Red #field
        about: "", //string md #field
        image: "", //string full image
        search: "", //string sql{search="tsv"} swift{skip}
        attr: {}, //map[string]any attributes sql{index} go{name="Attr"}
        price: {}, //map[string]any 
        purchase: {}, //map[string]any 
        location: {}, //map[string]any sql{index}
        brand: {}, //map[string]any sql{index}
        images: {}, //map[string]any hash = []file
        meta: {}, //map[string]any         
      }

      // init type
      asset.type = this.asset.type
      asset.purchase.curr = 'usd'

      asset.purchase = {
        geoid: 0, //int 
        country: "", //string 
        city: "", //string 
        state: "", //string 
        zip: "", //string 
        address: "", //string 
        place: "", //string 
        year: 0, //int 2022
        unix: 0, //int64 2022
        date: "", //string js yyyy-mm-dd
        auction: false, //bool on auction
        box: false, //bool has origin box
        curr: "", //string CLS-500, Submariner, Woman in Red #field
        reciept: "", //string file
        price: 0, //int geoid
      }
      
      // replace asset
      this.asset = asset
      // this.asset.status = 1 //new

      // init attr
      let fields = this.dict.attr.list(asset.type)
      fields.forEach(item => {
        if (item.multi) this.asset.attr[item.name] = []
        if (item.type == 'country') this.asset.attr[item.name] = 'us'
        if (item.type == 'price') this.asset.attr[item.name+'/curr'] = 'usd'
      });

      console.log('reset asset')
      console.log('reset asset fields', fields)

    },

    resetProgress(){
      this.progress = {
        status: undefined, 
        valid: false,                
        images: false,
        files: false,
        done: false,
        cancel: false,
        error: undefined,                
      }
    },

    valid(){
      let err = {}
      let a = this.asset
      let c = this.meta      

      if (c.brand.active && c.brand.must && !a.brand.id) err.brand = 'You have to fill title'
      if (c.model.active && c.model.must && !a.brand.model) err.model = 'You have to fill title'
      if (c.submodel.active && c.submodel.must && !a.brand.submodel) err.submodel = 'You have to fill title'

      if (c.title.active && c.title.must && !a.title) err.title = 'You have to fill title'
      if (c.about.active && c.about.must && !a.about) err.about = 'You have to fill about'
      if (c.location.active && c.location.must && !a.location.id) err.location = 'You have to choose a location'
      
      if (c.purchase.year.active && c.purchase.year.must && !a.purchase.year) err[`purchase/year`] = 'You have to fill title'
      if (c.purchase.location.active && c.purchase.location.must && !a.purchase.geoid) err[`purchase/location`] = 'You have to fill title'
      if (c.purchase.price.active && c.purchase.price.must && (!a.purchase.price || !a.purchase.curr)) err[`purchase/price`] = 'You have to fill title'

      console.log('attr errors', this.attrFields)
      for (let x = 0; x < this.attrFields.length; x++) {
        const item = this.attrFields[x];
        if (item.req){
          if (item.multi){
            if (!this.asset.attr[item.name] || !this.asset.attr[item.name].length) err['attr/'+item.name] = "Please fix this field"
          } else{
            if (!this.asset.attr[item.name]) err['attr/'+item.name] = "Please fix this field"
          }
          
        }  
      }

      if (!this.images.length) err.images = "You have to add images..."      
      if (this.images.length < this.minimumImages) err.images = `You have to upload minimum ${this.minimumImages} images`      
      // if (!this.asset.uid) err.user = "You have select user..."
      
      if (Object.keys(err).length) {        
        this.errors = err
        return true
      }
    },

    async getBrands(){      
      let asset = this.assetType
      let limit = 16      
      let fields = ['id','title']
      let res = await this.api.send('dict/brands',{asset, fields, limit, name:'brands'})
      if (res.error){
        return []
      }
      this.branditems = res.resp      
    },

    async getModels(){
      let brand = this.assetBrand
      let limit = 30      
      let fields = ['id','title']
      let res = await this.api.send('dict/models',{brand, fields, limit, name:'models'})
      if (res.error){
        return []
      }
      this.modelitems = res.resp      
    },
    
    async create(){
      
      let p = this.progress
      console.log('create asset')
      p.status = 'Validation...'
      let err = this.valid()
      
      if (err) {
        console.log('create asset errors')
        p.status = undefined
        return
      }

      console.log(this.asset)
      // return

      if (p.cancel) {this.resetProgress(); return}

      p.valid = true
      p.status = 'Images uploading...'

      let images = this.images
      for (let x = 0; x < images.length; x++) {
        const image = images[x];
        if (p.cancel) {this.resetProgress(); return}
        // upload link
        let link = await this.uploadImage(image.file)
        if (!link) {
          console.error(image)
          return
        }

        console.log('image upload',link)

        // add image
        this.asset.images[link] = true
        
        // cover
        if (x == 0) this.asset.image = link
        
      }
      if (p.cancel) {this.resetProgress(); return}
      p.images = true

      
      p.status = 'Files uploading...'
      p.files = true


      p.status = 'Publishing...'
      
      console.log('send')
      let res = await this.api.send('assets/create', this.asset)
      if (res.error){
        console.error(res.error)
        p.status = 'Error'
        p.error = `Publishing error: ${res.error}`
        return
      }
      console.log('created')

      p.done = true
      p.status = 'Done'

    },


    
    
  },
});

</script>
<style scoped>

</style>